import script from "./CommonModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonModal.vue?vue&type=script&setup=true&lang=ts"

import "./CommonModal.vue?vue&type=style&index=0&id=2e0206b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0206b2"]])

export default __exports__